<template>
	<div class="content">	    
		<el-row type="flex" justify="center" style="padding-top: 10px;">
			版权所有© <a>襄阳为兴投资管理有限公司</a><img src="//gw.alicdn.com/tfs/TB1jwakrbH1gK0jSZFwXXc7aXXa-20-20.png" style="width:20px;vertical-align: -2px; margin-right: 4px;height:20px;" p-id="60" data-spm-anchor-id="a313x.7781069.1998910419.i2">鄂ICP备20014822号</a>
		</el-row>	
	</div>
</template>

<script>
export default {
  name: 's-copyRight', 
  data () {
	return {
		
	}
  },
  mounted() {
	 
  },
  methods:{
	
  }
  
}
	
</script>
<style>
	 
	
	
</style>


// WEBPACK FOOTER //
// src/components/copy-right.vue